import PropTypes from 'prop-types';
import OfficeViewer from './OfficeViewer';
import PDFViewer from './PDFViewer';

const DocumentViewer = (props) => {
  const {
    url,
    fileName,
    setError,
    subType,
    pdfConfig,
    setPdfConfig,
    modal,
  } = props;
  if (!url) return null;

  // Usar el visor de Microsoft Office para todos los formatos de Office
  if (['word', 'excel', 'powerpoint'].includes(subType)) {
    return <OfficeViewer 
      fileName={fileName}
      contentUrl={url}
      setError={setError}
    />;
  }

  switch (subType) {
    case 'pdf':
      return <PDFViewer
        url={url}
        setError={setError}
        pdfConfig={pdfConfig}
        setPdfConfig={setPdfConfig}
        modal={modal}
      />;
    default:
      return (
        <iframe
          src={`https://docs.google.com/gview?url=${encodeURIComponent(url)}&embedded=true`}
          width="100%"
          height="500px"
          frameBorder="0"
          title="Document preview"
        />
      );
  }
};

DocumentViewer.propTypes = {
  url: PropTypes.string,
  fileName: PropTypes.string,
  setError: PropTypes.func,
  subType: PropTypes.string,
  pdfConfig: PropTypes.object,
  setPdfConfig: PropTypes.func,
  modal: PropTypes.bool,
};

export default DocumentViewer;
